import type { WavespeedModelConfig } from '../types';
import { clampTo, hasImageInput } from '../../tools';

export const lumaConfigs: Record<string, WavespeedModelConfig> = {
    'luma/uni-v1/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/luma/uni-v1/text-to-image
        apiPath: '/luma/uni-v1/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                size: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '3:1', '1:3', '3:2', '2:3', '2:1', '1:2', '1:1'] as const, '16:9'),
                // 图片 URL
                reference: image_urls.slice(0, 3).map((u: string) => ({ image_url: u, strength: 1 })),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'jpeg',
                    ['jpeg', 'png', 'webp'] as const,
                    'jpeg',
                ),
            };
        },
    },
    'luma/uni-v1/edit': {
        // https://wavespeed.ai/zh-CN/models/luma/uni-v1/edit
        apiPath: '/luma/uni-v1/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, providerOptions } = params;
            return {
                prompt: prompt,
                // 图片 URL
                image: image_urls[0],
                reference: image_urls.slice(1, 4),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'jpeg',
                    ['jpeg', 'png', 'webp'] as const,
                    'jpeg',
                ),
            };
        },
    },
};